<script lang="ts" module>
  import type { Snippet } from 'svelte';

  import Icon from '@/ui/base/icon/Icon.svelte';
  import Logo from '@/ui/base/Logo.svelte';

  import CtaButton from '../buttons/CTAButton.svelte';
  import LinkLoginButton, { type LinkLoginButtonProps } from '../buttons/LinkLoginButton.svelte';

  export interface LoginCardProps {
    headline: string;
    text?: string;
    textHtml?: Snippet;
    children?: Snippet;
    preLink?: LinkLoginButtonProps;
    postLink?: LinkLoginButtonProps;
    ctaLabel: string;
    onSubmit?: () => void;
    validate?: () => boolean;
    showNWP?: boolean;
  }
</script>

<script lang="ts">
  let { showNWP: showNWPProp = false, ...props }: LoginCardProps = $props();
  let loading: boolean = $state(false);
</script>

<div class="grid w-[492px] gap-6 rounded-md bg-white px-6 pb-[56px] pt-6 text-center shadow-card">
  <div class="flex items-center justify-center">
    <Logo scale={0.8}></Logo>
    {#if showNWPProp}
      <div class="flex-1"></div>
      <Icon icon="NWPLogo" size={19}></Icon>
    {/if}
  </div>
  <div class="grid justify-center pt-6">
    <h0 class="font-sans text-[20px] font-semibold text-c-base">{props.headline}</h0>
    <p class="w-[320px] pt-3 font-sans text-sm font-normal text-c-base">
      {#if props.textHtml}
        {@render props.textHtml()}
      {:else if props.text}
        {props.text}
      {/if}
    </p>
    <form
      class="grid pt-8"
      onsubmit={(event: Event) => {
        event.preventDefault();
        loading = true;
        if (props.validate ? props.validate() : true) {
          props.onSubmit?.();
        }
        loading = false;
      }}
    >
      {#if props.preLink}
        <div class="flex justify-center">
          <div class="flex w-[280px] justify-end pb-2">
            <LinkLoginButton {...props.preLink}></LinkLoginButton>
          </div>
        </div>
      {/if}
      <div class="grid gap-8">
        {#if props.children}
          {@render props.children()}
        {/if}
        <div class="flex justify-center">
          <CtaButton type="submit" class="w-[280px]" {loading}>{props.ctaLabel}</CtaButton>
        </div>
      </div>
      {#if props.postLink}
        <div class="pt-4">
          <LinkLoginButton {...props.postLink}></LinkLoginButton>
        </div>
      {/if}
    </form>
  </div>
</div>
